import React from 'react'

export const Forbidden = () => <p>Forbidden</p>

export default Forbidden
